"use strict";
/**
 * Alert timing formatters shared by web-hub and mobile. Every timestamp on
 * `SensorAlert` (`timestamp`, `triggeredAt`, `firstTriggeredAt`, `clearedAt`)
 * is epoch SECONDS, not milliseconds.
 *
 * Deliberately dependency-free (no date-fns) so `common` stays lean — output
 * matches web-hub's original date-fns implementation exactly.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAlertDuration = exports.formatAlertStart = exports.alertEpochToDate = void 0;
const MONTHS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];
const alertEpochToDate = (epochSeconds) => new Date(epochSeconds * 1000);
exports.alertEpochToDate = alertEpochToDate;
/** `3:42 PM` when the alert started today, `3:42 PM · Jul 28` otherwise. */
const formatAlertStart = (epochSeconds) => {
    const date = (0, exports.alertEpochToDate)(epochSeconds);
    const now = new Date();
    const sameDay = date.getFullYear() === now.getFullYear() &&
        date.getMonth() === now.getMonth() &&
        date.getDate() === now.getDate();
    const hours = date.getHours() % 12 || 12;
    const suffix = date.getHours() >= 12 ? 'PM' : 'AM';
    const time = `${hours}:${String(date.getMinutes()).padStart(2, '0')} ${suffix}`;
    return sameDay ? time : `${time} · ${MONTHS[date.getMonth()]} ${date.getDate()}`;
};
exports.formatAlertStart = formatAlertStart;
/** Coarse duration label: `2d 3h` / `1h 22m` / `45m` / `<1m`. */
const formatAlertDuration = (totalSeconds) => {
    const seconds = Math.max(0, Math.floor(totalSeconds));
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    if (days > 0)
        return `${days}d ${hours}h`;
    if (hours > 0)
        return `${hours}h ${minutes}m`;
    if (minutes > 0)
        return `${minutes}m`;
    return '<1m';
};
exports.formatAlertDuration = formatAlertDuration;
